import { useState } from "react";
// ui
import {
  Button,
  Typography,
  Modal,
  Box,
  TextField,
  FormControl,
  FormHelperText,
  Select,
  MenuItem,
  InputLabel,
  Checkbox,
  Paper,
} from "@mui/material";
import { styled } from "@mui/system";
import EditNoteIcon from "@mui/icons-material/EditNote";

// InterFace
import { EditDataDifine } from "../../config/dataInterface";
import { LIST_POST } from "../../config/const";
import { useWindowSize } from "../../lib/useWindowSize";

interface SystemConfigEditModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  editSystemConfig: {
    status: "before" | "editing" | "success" | "failed" | string;
    key: string;
    value: string;
    name: string;
  } | null;
  setEditSystemConfig: (
    data: {
      status: "before" | "editing" | "success" | "failed" | string;
      key: string;
      value: string;
      name: string;
    } | null
  ) => void;
  putEditData: () => void;
}
const CustomTextField = styled(TextField)({
  "& .MuiInputBase-input": {
    fontSize: "12px",
    height: "12px", // ここでフォントサイズを指定
  },
});
CustomTextField.defaultProps = {
  autoComplete: "off",
};
export function SystemConfigEditModal(props: SystemConfigEditModalProps) {
  const {
    onModal,
    swCloseModal,
    editSystemConfig,
    setEditSystemConfig,
    putEditData,
  } = props;
  const { windowWidth, windowHeight } = useWindowSize();
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: windowWidth > 868 ? "800px" : "calc(100% - 82px)",
    maxHeight: "70vh",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  return editSystemConfig ? (
    <Modal
      open={onModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} data-testid="system-config-edit-modal">
        <Box
          style={{
            fontSize: "18px",
            color: "rgb(50 50 50)",
          }}
          key="serchTitleBox"
          className="shippori-antique-regular"
        >
          編集 - {editSystemConfig.name}
        </Box>
        <Typography
          id="modal-modal-description"
          sx={{
            mt: 2,
            mb: 5,
            maxHeight: windowWidth > 385 ? undefined : "calc(70vh - 30px)",
            overflowY: windowWidth > 385 ? undefined : "auto",
          }}
        >
          <Paper elevation={0}>
            {editSystemConfig.status === "before" ? (
              <>
                <Box key="old-pass">
                  <Box className="serch-label">変更後</Box>
                  <CustomTextField
                    id="textFieldId"
                    value={editSystemConfig.value}
                    size="small"
                    onChange={(e) =>
                      setEditSystemConfig({
                        ...editSystemConfig,
                        value: e.target.value,
                      })
                    }
                    sx={{ width: "calc(100% - 10px)", margin: "10px 5px " }}
                  />
                  {editSystemConfig.key == "password_master_account" ||
                  editSystemConfig.key == "password_staff_account" ? (
                    <FormHelperText
                      id="serch-name"
                      sx={{
                        width: "calc(100% - 10px)",
                        textAlign: "right",
                        marginTop: "-8px",
                        marginRight: "5px",
                        height: "25px",
                      }}
                    >
                      ※既存の
                      {editSystemConfig.key == "password_master_account"
                        ? "マスター"
                        : "スタッフ"}
                      アカウントの初期パスワードは変更されません。
                    </FormHelperText>
                  ) : null}
                </Box>
                <Box
                  style={{ display: windowWidth > 385 ? "flex" : undefined }}
                >
                  <Box
                    style={{
                      marginTop: "10px",
                      height: "40px",
                      width:
                        windowWidth > 385
                          ? "calc(50% - 5px)"
                          : "calc(100% - 10px)",
                      marginLeft: windowWidth > 385 ? undefined : "5px",
                    }}
                  >
                    <Button
                      data-testid="system-config-edit-submit"
                      disabled={editSystemConfig.value === ""}
                      variant="contained"
                      style={{
                        height: "40px",
                        width: "100%",
                        textTransform: "none",
                      }}
                      onClick={putEditData}
                    >
                      <Box
                        className="m-plus-rounded-1c-regular"
                        style={{
                          color:
                            editSystemConfig.value === ""
                              ? "rgb(70 70 70)"
                              : undefined,
                        }}
                      >
                        編集
                      </Box>
                      <EditNoteIcon
                        sx={{
                          marginLeft: "6px",
                          color:
                            editSystemConfig.value === ""
                              ? "rgb(70 70 70)"
                              : "white",
                        }}
                        fontSize="medium"
                      />
                    </Button>
                  </Box>
                  <Box
                    style={{
                      marginTop: "10px",
                      height: "40px",
                      width:
                        windowWidth > 385
                          ? "calc(50% - 5px)"
                          : "calc(100% - 10px)",
                      marginLeft: windowWidth > 385 ? "10px" : "5px",
                    }}
                  >
                    <Button
                      data-testid="system-config-edit-cancel"
                      variant="contained"
                      style={{
                        height: "40px",
                        width: "100%",
                        textTransform: "none",
                      }}
                      onClick={swCloseModal}
                    >
                      <Box className="m-plus-rounded-1c-regular">
                        キャンセル
                      </Box>
                    </Button>
                  </Box>
                </Box>
              </>
            ) : editSystemConfig.status === "success" ? (
              <>
                <Box className="shippori-antique-regular">
                  値の編集に成功しました。
                </Box>
                <Box>
                  <Button
                    data-testid="system-config-edit-success-close"
                    style={{
                      marginTop: "30px",
                      marginLeft: windowWidth > 385 ? "15%" : "5px",
                      marginBottom: "-25px",
                      height: "40px",
                      width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                      textTransform: "none",
                    }}
                    variant="contained"
                    onClick={swCloseModal}
                  >
                    <Box className="m-plus-rounded-1c-regular">閉じる</Box>
                  </Button>
                </Box>
              </>
            ) : editSystemConfig.status === "failed" ? (
              <>
                <Box className="shippori-antique-regular">
                  編集に失敗しました。
                  <br />
                  データの形式が異なる可能性があります。
                </Box>
                <Box>
                  <Button
                    data-testid="system-config-edit-failed-back"
                    style={{
                      marginTop: "30px",
                      marginLeft: windowWidth > 385 ? "15%" : "5px",
                      marginBottom: "-25px",
                      height: "40px",
                      width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                      textTransform: "none",
                    }}
                    variant="contained"
                    onClick={() =>
                      setEditSystemConfig({
                        ...editSystemConfig,
                        status: "before",
                      })
                    }
                  >
                    <Box className="m-plus-rounded-1c-regular">OK</Box>
                  </Button>
                </Box>
              </>
            ) : editSystemConfig.status === "NotPasswordPolicy" ? (
              <>
                <Box className="shippori-antique-regular">
                  パスワードの要件を満たしていません。
                  <br />
                  大文字・小文字・数字・記号を含む
                  <br />
                  8文字以上の文字列をご入力ください。
                </Box>
                <Box>
                  <Button
                    data-testid="system-config-edit-password-back"
                    style={{
                      marginTop: "30px",
                      marginLeft: windowWidth > 385 ? "15%" : "5px",
                      marginBottom: "-25px",
                      height: "40px",
                      width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                      textTransform: "none",
                    }}
                    variant="contained"
                    onClick={() =>
                      setEditSystemConfig({
                        ...editSystemConfig,
                        status: "before",
                      })
                    }
                  >
                    <Box className="m-plus-rounded-1c-regular">OK</Box>
                  </Button>
                </Box>
              </>
            ) : (
              <>
                <Box className="shippori-antique-regular">
                  {editSystemConfig.status}
                </Box>
                <Box>
                  <Button
                    style={{
                      marginTop: "30px",
                      marginLeft: windowWidth > 385 ? "15%" : "5px",
                      marginBottom: "-25px",
                      height: "40px",
                      width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                      textTransform: "none",
                    }}
                    variant="contained"
                    onClick={() =>
                      setEditSystemConfig({
                        ...editSystemConfig,
                        status: "before",
                      })
                    }
                  >
                    <Box className="m-plus-rounded-1c-regular">OK</Box>
                  </Button>
                </Box>
              </>
            )}
          </Paper>
        </Typography>
      </Box>
    </Modal>
  ) : null;
}
